import { GameState, SaveData } from './types';
import { CHOP_HITS } from './constants';

const SAVE_KEY = 'hello_robot_save';

export function saveGame(state: GameState): void {
  const data: SaveData = {
    player: {
      x: state.player.x,
      y: state.player.y,
      wood: state.player.wood,
      coins: state.player.coins,
      spears: state.player.spears,
      hasSuperAxe: state.player.hasSuperAxe,
    },
    trees: state.trees.map(t => ({
      gridX: t.gridX,
      gridY: t.gridY,
      hp: t.hp,
      regrowTimer: t.regrowTimer,
    })),
    buildings: state.buildings.map(b => ({ ...b })),
    baseLevel: state.baseLevel,
    tutorialStep: state.tutorialStep,
    hasWon: state.hasWon,
    totalTime: state.totalTime,
  };

  try {
    localStorage.setItem(SAVE_KEY, JSON.stringify(data));
  } catch {
    // localStorage might be full or unavailable
  }
}

export function loadSave(): SaveData | null {
  try {
    const raw = localStorage.getItem(SAVE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as SaveData;
  } catch {
    return null;
  }
}

export function applySave(state: GameState, save: SaveData): void {
  state.player.x = save.player.x;
  state.player.y = save.player.y;
  state.player.wood = save.player.wood;
  state.player.coins = save.player.coins;
  state.player.spears = save.player.spears;
  state.player.hasSuperAxe = save.player.hasSuperAxe;

  // Restore trees
  for (const savedTree of save.trees) {
    const tree = state.trees.find(t => t.gridX === savedTree.gridX && t.gridY === savedTree.gridY);
    if (tree) {
      tree.hp = savedTree.hp;
      tree.regrowTimer = savedTree.regrowTimer;
    }
  }

  state.buildings = save.buildings.map(b => ({ ...b }));
  state.baseLevel = save.baseLevel;
  state.tutorialStep = save.tutorialStep;
  state.hasWon = save.hasWon;
  state.totalTime = save.totalTime;
}

export function clearSave(): void {
  try {
    localStorage.removeItem(SAVE_KEY);
  } catch {
    // ignore
  }
}
